import SearchUserAndInvite from './SearchUserAndInvite'
import ScaleUserListItem from './ScaleUserListItem'
import ConfirmDialog from '@/modals/ConfirmDialog'

import { fbFullUpdate, apiIsUserInDuty, createShift, apiCheckUserDutyConflictInGroup } from '@/services/firebase'

import { freeVersion } from '@/constants'
import { canAddUserShift } from '@/functions'
import { formatDbTime } from '@/mixins/utils'

import StringMixin from '@/mixins/string.mixin'
import confirmDialogMixin from '@/mixins/cd.mixin.js'

import { mapState } from 'vuex'

import { isUserPlanOld } from '@/utils.js'

import moment from 'moment'
import 'moment/locale/pt-br'
import { CHECK_RULE_VIOLATION } from '../../../../../store/working-hours-rules/types'

moment.locale('pt-BR')

//
//
//

const getRecentUsers = groupID => {
  const recentesKey = `@sosplantao_grupo_${groupID}`
  const recentes = localStorage.getItem(recentesKey)

  // console.log('::: getRecentUsers:', recentesKey, recentes)

  if (!!recentes === false) return { code: 0, response: [], error: '' }

  try
  {
    return { code: 1, response: JSON.parse(recentes), error: '' }
  }
  catch (error)
  {
    localStorage.removeItem(recentesKey)

    // console.log('::: getRecentUsers > ERROR:', recentesKey, recentes, error)

    return { code: 0, response: [], error }
  }
}

//
//
//

export default {
  name: 'AddUserDialog',

  components: {
    'confirm-dialog': ConfirmDialog,
    'scale-user-list-item': ScaleUserListItem,
    'search-user-and-invite': SearchUserAndInvite,
  },

  mixins: [
    StringMixin,
    confirmDialogMixin,
  ],

  data ()
  {
    return {
      freeVersion,

      visible: false,
      loading: false,
      isMultiSelectActive: false,
      search: '',
      selectedUsers: [],
      recentes: [],

      //
      //
      //

      scaleName: '',
      scaleLocation: { id: '', name: '' },
      scaleTurns: [],
      scaleUsers: null,

      groupID: '',
      grupoNome: '',

      turnID: '',
      turnoDados: null,

      date: {},

      _multiSelectQueue: [],
      _multiSelectIndex: 0,
      _currentContextUser: null,
      _currentContextArgs: null,
    }
  },

  computed: {
    ...mapState({
      userSession: state => state.app.userSession,
      groupUsers: state => state.app.groupUsers,
      groupScales: state => state.app.groupScales,
    }),

    //
    //
    //

    dialogTitle () {
      return !!this.date === true && !!this.date.day === true ? `Adicionar plantão no dia ${this.date.day.format('DD/MM/YYYY')}` : 'Adicionar plantão'
    },

    //
    //
    //

    processedGroupScales () {
      return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
    },

    processedGroupUsers ()
    {
      if (this.processedGroupScales.length === 0) return []

      const groupUsers = !!this.groupUsers === true && Array.isArray(this.groupUsers) && this.groupUsers.length > 0 ? this.groupUsers : []

      // ESCALAS DE CADA USUÁRIO DO GRUPO
      const usersScales = Object.fromEntries(
        groupUsers.map(gu => ([
          gu.userID,
          this.processedGroupScales.filter(gs => gs.scaleRelatedUsers.some(userID => userID === gu.userID)).map(gs => gs.scaleID),
        ]))
      )

      // USUÁRIOS QUE NÃO TEM A ESCALA (ATUAL) RELACIONADA OU USUÁRIOS QUE TEM ESSA ESCALA (ATUAL) SELECIONADA
      const users = groupUsers.filter(gu => (
        (
          // Usuário não encontrado
          !!usersScales[gu.userID] === false
        ) ||
        (
          // Usuário encontrado + Relacionado a todas as escalas (Nota: Segundo a regra de negócio = Nenhuma escala relacionada)
          !!usersScales[gu.userID] === true &&
          usersScales[gu.userID].length === 0
        ) ||
        (
          // Usuário encontrado + Relacionado a escala do plantão a ser dividido
          !!usersScales[gu.userID] === true &&
          usersScales[gu.userID].length > 0 &&
          usersScales[gu.userID].some(scaleID => scaleID === this.$route.params.scaleID)
        )
      ))

      return users
    },

    //
    //
    //

    isSearch: function () {
      return this.processedGroupUsers.length > 1 && this.search.trim().length >= 3
    },

    isFreeOrExpired: function () {
      return (
        !freeVersion &&
        this.processedGroupUsers.length > Number(this.userSession.userCapabilities.limiteUsuarios) &&
        isUserPlanOld(this.userSession.planId) === false
      )
    },

    usuarios: function ()
    {
      if (this.processedGroupUsers.length === 0) return []

      let usuariosDoGrupo = this.processedGroupUsers.slice()

      const textToSearch = this.search.trim()
      const isSearch = usuariosDoGrupo.length > 1 && textToSearch.length >= 3 // O grupo tem mais de 1 usuário [e] O campo de busca tem mais de 3 caracteres

      // Ordenar usuários do grupo (sem recentes) em ordem alfabética
      usuariosDoGrupo.sort((a, b) => a.userName.localeCompare(b.userName))

      //
      //
      //

      if (!isSearch)
      {
        //
        // Retira os usuários recentes da lista de usuários do grupo, porque visualmente serão duas listas separadas.
        //

        if (this.recentes.length > 0 && !isSearch) {
          usuariosDoGrupo = usuariosDoGrupo.filter(user => !this.recentes.some(recente => recente.userID === user.userID))
        }

        //
        // Retira os usuários "inacessíveis" da lista de usuários do grupo, porque são 3 listas separadas:
        // - USUÁRIOS RECENTES
        // - USUÁRIOS ACESSÍVEIS
        // - USUÁRIOS INACESSÍVEIS (quando o plano atual do usuário tem limite de usuários)
        //
        // "Verificar se os usuários salvos estão "visíveis" para o plano atual do usuário"
        //

        if (this.usuariosInacessiveis.length > 0 && !isSearch) {
          usuariosDoGrupo = usuariosDoGrupo.filter(recente => !this.usuariosInacessiveis.some(user => user.userID === recente.userID))
        }

        // Output
        return usuariosDoGrupo
      }
      else
      {
        const listaFiltrada = usuariosDoGrupo.filter((user, index) => {
          const nome = user.userName

          const email = user.userEmail ? user.userEmail.trim() : ''

          const cpf = user.userCpf ? user.userCpf.trim() : ''
          const cpfNumbers = cpf.length > 0 ? cpf.replace(/[^0-9]/g, '') : ''

          const cnpj = user.userCnpj ? user.userCnpj.trim() : ''
          const cnpjNumbers = cnpj.length > 0 ? cnpj.replace(/[^0-9]/g, '') : ''

          const tel = user.userPhone ? user.userPhone.trim() : ''
          const telNumbers = tel.length > 0 ? tel.replace(/[^0-9]/g, '') : ''

          // console.log('::: index:', user.userName, index)

          return this.isFreeOrExpired && (index + 1) > Number(this.userSession.userCapabilities.limiteUsuarios) ? false : (
            (nome.length > 0 ? (nome.toUpperCase().indexOf(textToSearch.toUpperCase()) !== -1) : false) ||

            (email.length > 0 ? (email.toUpperCase().indexOf(textToSearch.toUpperCase()) !== -1) : false) ||

            (cpf.length > 0 ? (cpf.indexOf(textToSearch) !== -1) : false) ||
            (cpfNumbers.length > 0 ? (cpfNumbers.indexOf(textToSearch) !== -1) : false) ||

            (cnpj.length > 0 ? (cnpj.indexOf(textToSearch) !== -1) : false) ||
            (cnpjNumbers.length > 0 ? (cnpjNumbers.indexOf(textToSearch) !== -1) : false) ||

            (tel.length > 0 ? (tel.indexOf(textToSearch) !== -1) : false) ||
            (telNumbers.length > 0 ? (telNumbers.indexOf(textToSearch) !== -1) : false)
          )
        })

        // Aplica ordenação alfabética nos resultados
        if (listaFiltrada.length > 0) listaFiltrada.sort((a, b) => a.userName.localeCompare(b.userName))

        // Output
        return listaFiltrada.length > 0 ? listaFiltrada : []
      }
    },

    //
    //
    //
    // USUÁRIOS RECENTES / SALVOS NO NAVEGADOR
    //
    //
    //

    usuariosRecentes: function ()
    {
      if (this.processedGroupUsers.length === 0 || this.recentes.length === 0) return []

      const usuariosDoGrupo = this.processedGroupUsers.slice()

      // console.log('::: USUÁRIOS RECENTES -> usuariosDoGrupo:', usuariosDoGrupo)

      // Verificar se os usuários salvos no navegador ainda estão no grupo
      let recentesEncontradosNoGrupo = this.recentes.filter(recente => usuariosDoGrupo.some(user => user.userID === recente.userID))

      // console.log('::: USUÁRIOS RECENTES [1]:', recentesEncontradosNoGrupo)

      //
      // Retira os usuários "inacessíveis" da lista de usuários do grupo, porque são 3 listas separadas:
      // - USUÁRIOS RECENTES
      // - USUÁRIOS ACESSÍVEIS
      // - USUÁRIOS INACESSÍVEIS (quando o plano atual do usuário tem limite de usuários)
      //
      // "Verificar se os usuários salvos estão "visíveis" para o plano atual do usuário"
      //

      if (this.usuariosInacessiveis.length > 0) {
        recentesEncontradosNoGrupo = recentesEncontradosNoGrupo.filter(recente => !this.usuariosInacessiveis.some(user => user.userID === recente.userID))
      }

      // console.log('::: USUÁRIOS RECENTES [2]:', recentesEncontradosNoGrupo)

      // Montar a lista de usuários recentes usando os detalhes dos usuários no grupo
      recentesEncontradosNoGrupo = recentesEncontradosNoGrupo.length > 0 ? recentesEncontradosNoGrupo.map(saved => {
        const user = usuariosDoGrupo.find(user => user.userID === saved.userID)
        return { date: saved.date || 0, userID: user.userID, backup: user.backup, userEmail: user.userEmail, userName: user.userName, userImage: user.userImage, userImageIsValid: user.userImageIsValid }
      }) : []

      // Ordenar lista de usuários recentes: Mais clicados no topo
      if (recentesEncontradosNoGrupo.length > 0) recentesEncontradosNoGrupo.sort((a, b) => b.date - a.date)

      // Output
      return recentesEncontradosNoGrupo.length > 0 ? recentesEncontradosNoGrupo : []
    },

    //
    //
    //
    // USUÁRIOS QUE NÃO PODEM SER TRABALHADOS DENTRO DO PLANO ATUAL
    //
    //
    //

    usuariosInacessiveis: function ()
    {
      if (this.processedGroupUsers.length === 0) return []

      let usuariosDoGrupo = this.processedGroupUsers.slice()

      // Ordenar usuários do grupo (sem recentes) em ordem alfabética
      usuariosDoGrupo.sort((a, b) => a.userName.localeCompare(b.userName))

      // Montar a lista de usuários para comparação
      usuariosDoGrupo = usuariosDoGrupo.length > 0 ? usuariosDoGrupo.map((user, index) => ({ index, ...user })) : []

      // console.log('::: USUÁRIOS INACESSÍVEIS:', usuariosDoGrupo)

      // Retirar usuários "visíveis"
      usuariosDoGrupo = usuariosDoGrupo.length > 0 ? usuariosDoGrupo.filter(user => this.isFreeOrExpired && (user.index + 1) > Number(this.userSession.userCapabilities.limiteUsuarios)) : []

      // console.log('::: USUÁRIOS INACESSÍVEIS:', usuariosDoGrupo)

      // Output
      return usuariosDoGrupo
    },

    //
    //
    //
    // FUNÇÕES UTILITÁRIAS PARA IDENTIFICAR E TRATAR CONDIÇÕES ESPECÍFICAS PARA O PLANO ATUAL DO USUÁRIO
    //
    //
    //

    areUsersVisible: function () {
      return Number(this.userSession.userCapabilities.limiteUsuarios) >= this.processedGroupUsers.length
    },

    //
    //
    //
    // SIMULAÇÃO DE PLANO LIMITADO
    //
    //
    //

    /*
    userPlanId: function () {
      return 0
    },
    userPlanCategory: function () {
      return 'free'
    },
    usersLimit: function () {
      return 4
    },
    usersLimitDefault: function () {
      return 4
    },
    */
  },

  watch: {
    visible: {
      handler (atual, old)
      {
        if (atual === false) this.clearFields()
      },
    },
  },

  /* mounted () {
    // [24/01/25] console.log('::: ADD USER DIALOG -> mounted')
  },

  beforeDestroy () {
    // [24/01/25] console.log('::: ADD USER DIALOG -> beforeDestroy')
  }, */

  methods: {
    //
    //
    //
    // OPEN THIS WINDOW
    //
    //
    //

    open (args)
    {
      // console.log('OPEN > ::: ADD USER DIALOG:', args)

      //
      //
      //

      this.scaleName = args.scaleName
      this.scaleLocation = args.scaleLocation
      this.scaleTurns = args.scaleTurns
      this.scaleUsers = args.scaleUsers

      this.groupID = args.groupID
      this.grupoNome = args.grupoNome

      this.turnID = args.turnID
      this.turnoDados = args.turnoDados

      this.date = args.date

      //
      //
      //

      this.loading = false
      this.visible = true

      //
      // ?
      //

      const recentUsers = getRecentUsers(this.groupID)

      if (recentUsers.response.length > 0)
      {
        this.recentes = recentUsers.response.filter(recentUser => this.processedGroupUsers.some(groupUser => groupUser.userID === recentUser.userID))
      }

      // console.log('::: processedGroupUsers:', this.processedGroupUsers)
    },

    //
    //
    //
    // FREE MEMORY AFTER CLOSING THE WINDOW
    //
    //
    //

    clearFields ()
    {
      this.search = ''

      this.recentes = []

      this.scaleName = ''
      this.scaleLocation = { id: '', name: '' }
      this.scaleTurns = []
      this.scaleUsers = null

      this.groupID = ''
      this.grupoNome = ''

      this.turnID = ''
      this.turnoDados = null

      this.date = {}

      this.selectedUsers = [];
      this.isMultiSelectActive = false;
      this._multiSelectQueue = [];
      this._multiSelectIndex = 0;
      this._currentContextUser = null;
      this._currentContextArgs = null;
    },

    //
    //
    //
    // OPEN SEARCH USER WINDOW (ADD OR INVITE)
    //
    //
    //

    openSearchUserWindow ()
    {
      this.$refs.searchUserDialog.open({ groupID: this.groupID })
    },

    //
    //
    //
    // ADD USER TO SCALE
    // - VALIDATION BEFORE ADDING
    // - OR ADDIND
    //
    //
    //
    // Retorna um objeto para indicar o que aconteceu:
    // { success: true } se adicionado com sucesso
    // { success: false, reason: 'blocked' } se bloqueado por regra ou erro
    // { success: false, reason: 'confirm_needed', type: CD_TYPE, data: CD_DATA } se precisa de confirmação
    async addUserToScale (user, args = { checkScaleDutyManualConflicts: true, checkScaleDutyJourneyConflicts: true, checkDutyConflicts: true, checkRuleViolations: true })
    {
      if (
        !!user === false || (
          !!user === true && (
            !Object.prototype.hasOwnProperty.call(user, 'userID') ||
            !Object.prototype.hasOwnProperty.call(user, 'backup')
          )
        )
      ) return { success: false, reason: 'invalid_user_data' }

      //
      // -----------------------------------------------------------------------------------------------
      // INITIALIZE SOME DATA
      // -----------------------------------------------------------------------------------------------
      //

      const { date, turnID, turnoDados, grupoNome, scaleName, scaleLocation } = this;
      const { groupID, scaleID } = this.$route.params;

      if (!turnoDados || !turnoDados.hour || !date || !date.day) {
          // console.error("Erro: Dados de turno ou data estão faltando.", { turnoDados, date });
          this.showMessage('Erro', 'Dados de plantão incompletos. Por favor, tente novamente.');
          return { success: false, reason: 'missing_turn_data' };
      }

      const plantaoPlantonistaID = user.backup.uid
      const plantaoPlantonistaNome = String(user.backup.nome).trim()
      const dutyStartTime = formatDbTime(turnoDados.hour)
      const dataSemZero = date.day.format('YYYY-M-D')


      if (!!args.checkRuleViolations === true) {
        const ruleViolationResponse = await this.$store.dispatch(
          CHECK_RULE_VIOLATION,
          {
            userId: user.userID,
            date: dataSemZero,
            groupId: groupID,
            scaleId: scaleID,
            turnId: turnID,
            duration: turnoDados.duration,
            start_time: dutyStartTime,
          }
        );

        const { code, title, message, data } = ruleViolationResponse;

        if (code !== 'OK') {
          this.showMessage(title, message);
          return { success: false, reason: 'rule_violation_error', message: message };
        } else if (code === 'OK' && data.violated) {
          const primeiroNome = user.backup.nome.split(" ")[0];
          const plantaoPlantonistaNomeStyled = String(primeiroNome).trim();

          if (data.action === "block") {
            this.showMessage(
              "Ação Bloqueada",
              `<div style="text-align: center"><b style="color: slateblue">${plantaoPlantonistaNomeStyled}</b> não pode ser adicionado devido a uma violação de regra:<br /><br />${data.message}</div>`
            );
            return { success: false, reason: 'rule_violation_blocked' };
          } else if (data.action === "warn") {
            // Retorna para o chamador que uma confirmação é necessária
            return {
              success: false,
              reason: 'confirm_needed',
              type: CHECK_RULE_VIOLATION,
              data: { user: user, args: args },
              title: "Violação de Regra!",
              text: `<div style="text-align: center"><b style="color: slateblue">${plantaoPlantonistaNomeStyled}</b> possui uma violação de regra para <b style="color: orangered">${date.day.format(
                "DD/MM/YYYY"
              )} às ${dutyStartTime}</b>:<br /><br />${
                data.message
              }<br /><br /><b>Deseja adicionar o plantonista mesmo assim?</b></div>`,
              buttonPosition: "right",
              width: 330,
              closeText: "Não",
              continueText: "Sim",
            };
          }
        }
      }

      //
      // -----------------------------------------------------------------------------------------------
      // O PLANTONISTA JÁ FOI ADICIONADO EM OUTRAS ESCALAS NA DATA E TURNO DESEJADOS?
      // Nota: Apenas nas escalas (editar escala) do mesmo grupo
      // -----------------------------------------------------------------------------------------------
      //

      if (!!args.checkScaleDutyManualConflicts === true)
      {
        const foundConflicts = await apiCheckUserDutyConflictInGroup(groupID, user.userID, dataSemZero, turnoDados.hour)

        if (foundConflicts.length > 0)
        {
          let htmlTable = '<table class="tableConflicts">'
          htmlTable += '<tr><th style="padding: 0 7px">Escala</th><th style="padding: 0 7px">Quantidade</th></tr>'
          foundConflicts.forEach(r => {
            htmlTable += `<tr><td style="padding: 4px 7px; line-height: 0; word-break: break-all"><b style="color: indianred; line-height: 19px">${r.scaleName}</b></td><td><span style="display: inline-block; width: 100%; color: slategrey; font-size: 14px; line-height: 14px">${r.amount}</span></td></tr>`
          })
          htmlTable += '</table>'

          // Retorna para o chamador que uma confirmação é necessária
          return {
            success: false,
            reason: 'confirm_needed',
            type: 'CHECK_EXISTING_DUTIES_CONFLICT_BEFORE_ADDING',
            data: { user: user, args: args }, // Adiciona user e args para o cdAction
            title: 'Conflito!',
            text: `<div style="text-align: center"><b style="color: slateblue">${plantaoPlantonistaNome || 'O plantonista'}</b> já foi adicionado em <b style="color: orangered">${this.date.day.format('DD/MM/YYYY')} às ${dutyStartTime}</b> no grupo <b style="color: forestgreen">${grupoNome}</b>:<br /><br />${htmlTable}<br /><b>Deseja adicionar o plantonista mesmo assim?</b></div>`,
            buttonPosition: 'right',
            width: 330,
            closeText: 'Não',
            continueText: 'Sim',
          };
        }
      }

      //
      // -----------------------------------------------------------------------------------------------
      // PROCESSAR JORNADA PARA VERIFICAR CONFLITOS DE JORNADA NA ESCALA ATUAL
      // PROCESSAR JORNADA PARA GERAR PLANTÕES CONFORME A JORNADA SELECIONADA
      // -----------------------------------------------------------------------------------------------
      //

      const { jornada, journeyWorkingDays, journeyDaysOff } = this.$store.state.app.EditScale

      const processedWeeks = this.$store.state.app.EditScale.weeks.map(week => ({
        ...week,

        //
        // VERIFICA SE O PLANTÃO PODE SER COLOCADO NO TURNO
        // > SE SIM, ADICIONA NA ESCALA/PLANTÕES
        // > CASO CONTRÁRIO, MOSTRA UM ERRO/AVISO NA TELA
        //

        isReleasedWeek: (
          this.scaleTurns.length > 0 &&
          week.value.some(day => this.scaleTurns.some(turn => turn.plantoes && turn.plantoes[day.dayFmtWzero] && turn.plantoes[day.dayFmtWzero].confirmedDutys))
        ),
      }))

      //
      // -----------------------------------------------------------------------------------------------
      // CRIAR PLANTÕES (VER E EDITAR) CONFORME A JORNADA DESEJADA
      // -----------------------------------------------------------------------------------------------
      //

      const fbUpdate = await createShift({
        user: {
          uid: plantaoPlantonistaID,
          img: user.backup.img || '',
          nome: user.backup.nome,
        },
        userScaleHourlyRate: !!this.scaleUsers === true && !!this.scaleUsers[plantaoPlantonistaID] === true && !!this.scaleUsers[plantaoPlantonistaID].hourlyrate === true ? this.scaleUsers[plantaoPlantonistaID].hourlyrate : 0,
        jornada,
        journeyWorkingDays,
        journeyDaysOff,
        weeks: processedWeeks,
        turnID,
        turnoDados,
        dataSemZero,
        groupID,
        grupoNome,
        scaleID,
        scaleName,
        scaleLocation,
      })

      if (fbUpdate.code === 0)
      {
        this.showMessage('Erro', 'Não foi possível criar o plantão. Por favor, tente novamente ou fale com o nosso suporte.')
        return { success: false, reason: 'shift_creation_failed' };
      }

      //
      // -----------------------------------------------------------------------------------------------
      // O PLANTONISTA JÁ FOI ADICIONADO NAS DATAS DA JORNADA DESEJADA?
      // Nota: Apenas no editar escala da escala atual
      // -----------------------------------------------------------------------------------------------
      //

      const datasDaJornada = fbUpdate.dates

      if (!!args.checkScaleDutyJourneyConflicts === true)
      {
        const conflictDays = []

        for (var i = 0; i < datasDaJornada.length; i++)
        {
          // Parece que o firebase depende de zeros a esquerda... sem isso a consulta não funciona (Idéia: mixin para padronizar 0's em todo app)
          const journeyDateObj = moment(datasDaJornada[i], 'YYYY-M-D')

          if (await apiIsUserInDuty(groupID, scaleID, turnID, journeyDateObj.format('YYYY-M-D'), user.userID)) {
            conflictDays.push(`<span style="color: steelblue">${journeyDateObj.format('DD/MM/YYYY')}</span>`)
          }
        }

        // Senhor Jesus
        // COMO TRATAR: Se um plantão criado foi passado para outro usuário, o conflito continuará funcionando aqui.

        if (conflictDays.length > 0)
        {
          // Retorna para o chamador que uma confirmação é necessária
          return {
            success: false,
            reason: 'confirm_needed',
            type: 'CHECK_EXISTING_DUTIES_CONFLICT_BEFORE_ADDING',
            data: { user: user, args: args },
            title: 'Conflito!',
            text: `<div style="text-align: center"><b style="color: slateblue">${plantaoPlantonistaNome || 'O usuário'}</b> já foi adicionado na escala atual.<br /><br />Veja os conflitos abaixo:<br />${conflictDays.join('<br />')}<br /><br /><b>Deseja adicionar o plantonista mesmo assim?</b></div>`,
            buttonPosition: 'right',
            width: 330,
            closeText: 'Não',
            continueText: 'Sim',
          };
        }
      }

      //
      // -----------------------------------------------------------------------------------------------
      // O PLANTONISTA JÁ TEM PLANTÕES DISPARADOS NAS DATAS DA JORNADA DESEJADA?
      // Nota: Verificará plantões disparados em todos os grupos que o plantonista faz parte
      // -----------------------------------------------------------------------------------------------
      //

      if (!!args.checkDutyConflicts === true)
      {
        const firstWeek = processedWeeks[0]
        const firstDate = firstWeek.value[0].day

        const lastWeek = processedWeeks[processedWeeks.length - 1]
        const lastDate = lastWeek.value[6].day

        //
        // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
        //

        const journeyDates = datasDaJornada.map(dataDaJornada => moment(dataDaJornada, 'YYYY-M-D').format('DD/MM/YYYY'))

        const { conflictedScales = [], conflictsTableHtml = '' } = await canAddUserShift(dutyStartTime, journeyDates, plantaoPlantonistaID, firstDate, lastDate)

        if (conflictedScales.length > 0)
        {
          // Retorna para o chamador que uma confirmação é necessária
          return {
            success: false,
            reason: 'confirm_needed',
            type: 'ADD_USER',
            data: { user: user, args: args },
            title: 'Conflito!',
            text: `<div style="text-align: center">O plantão ${plantaoPlantonistaNome.length > 0 ? `de <b style="color: slateblue">${plantaoPlantonistaNome}</b>` : 'do <b style="color: slateblue">usuário selecionado</b>'} já foi criado ${ journeyDates.length === 1 ? `em <b style="color: orangered">${this.date.day.format('DD/MM/YYYY')} às ${dutyStartTime}</b>` : ` no turno das <b style="color: orangered">${dutyStartTime}</b> em uma ou mais datas da jornada <b style="color: steelblue">${jornada}</b>` }:<br /><br />${conflictsTableHtml}<br /><b>Deseja adicionar o plantonista mesmo assim?</b></div>`,
            buttonPosition: 'right',
            width: 330,
            closeText: 'Não',
            continueText: 'Sim',
          };
        }
      }

      //
      // -----------------------------------------------------------------------------------------------
      // EXECUTA ESCRITA NO FIREBASE
      // -----------------------------------------------------------------------------------------------
      //

      const response = await fbFullUpdate(fbUpdate.firebasePaths)

      if (response.code === 1)
        {
        // console.log('addUserToScale fbUpdate:', fbUpdate);
        // SALVA USUÁRIO NO NAVEGADOR OU ATUALIZA USUÁRIO SALVO NO NAVEGADOR
        const nowTimestamp = moment.utc().unix()
        const foundUser = this.recentes.find(recente => recente.userID === plantaoPlantonistaID)
        if (foundUser) {
          foundUser.date = nowTimestamp
        } else {
          this.recentes.push({ userID: plantaoPlantonistaID, date: nowTimestamp })
        }

        localStorage.setItem(`@sosplantao_grupo_${groupID}`, JSON.stringify(this.recentes))

        // ADICIONAR NO CTRL+Z
        this.$store.commit('SET_EDIT_SCALE_CTRL_Z', { type: 'add', data: fbUpdate.firebasePaths }) //

        return { success: true };
      }
      return { success: false, reason: 'firebase_update_failed' };
    },

    //
    //
    //
    // CONFIRM DIALOG OUTPUT/RESPONSE
    //
    //
    //

    async cdAction (cdResponse)
    {
      if (cdResponse === false) {
          this.loading = false;
          // caso a seleção múltipla esteja ativa, processa o próximo usuário
          if (this.isMultiSelectActive) {
            this.processNextSelectedUser(this._multiSelectIndex + 1);
          }
          // Se for seleção única, o modal permanece aberto ou a lógica de toggleUserSelection lida
          return;
      }

      const user = this._currentContextUser;
      let args = this._currentContextArgs;

      let updatedArgs = { ...args };

      if (cdResponse.cdType === CHECK_RULE_VIOLATION) {
          updatedArgs.checkRuleViolations = false;
      } else if (cdResponse.cdType === 'CHECK_EXISTING_DUTIES_CONFLICT_BEFORE_ADDING') {
          updatedArgs.checkScaleDutyManualConflicts = false;
          updatedArgs.checkScaleDutyJourneyConflicts = false;
      } else if (cdResponse.cdType === 'ADD_USER') {
          updatedArgs.checkScaleDutyManualConflicts = false;
          updatedArgs.checkScaleDutyJourneyConflicts = false;
          updatedArgs.checkDutyConflicts = false;
          updatedArgs.checkRuleViolations = false;
      }

      const result = await this.addUserToScale(user, updatedArgs);

      if (result.success) {
          if (this.isMultiSelectActive) {
              this.processNextSelectedUser(this._multiSelectIndex + 1);
          } else {
              this.visible = false;
              this.loading = false;
          }
      } else {
          // Se falhou mesmo após a confirmação (ex: erro no firebaseUpdate)
          this.loading = false;
          this.showMessage('Erro', `Não foi possível adicionar ${user.userName} após a confirmação. (${result.reason || 'erro desconhecido'})`);
          if (this.isMultiSelectActive) {
            this.processNextSelectedUser(this._multiSelectIndex + 1); // Em seleção múltipla, move para o próximo
          }
      }
      this._currentContextUser = null;
      this._currentContextArgs = null;
    },

    toggleMultiSelect() {
      this.isMultiSelectActive = !this.isMultiSelectActive;
      if (!this.isMultiSelectActive) {
        this.selectedUsers = [];
      }
    },

    async toggleUserSelection(user) {
      if (!this.isMultiSelectActive) {
        this.loading = true;

        this._currentContextUser = user;
        this._currentContextArgs = { checkScaleDutyManualConflicts: true, checkScaleDutyJourneyConflicts: true, checkDutyConflicts: true, checkRuleViolations: true };

        const result = await this.addUserToScale(user, this._currentContextArgs);

        if (result.success) {
          this.loading = false;
          this.visible = false;
        } else if (result.reason === 'confirm_needed') {
          this.loading = false; o
          // Chama o showConfirmBox com os dados retornados
          await this.showConfirmBox(result);
        } else {
          this.loading = false;
        }
        return;
      }

      const index = this.selectedUsers.findIndex(u => u.userID === user.userID);
      if (index > -1) {
        this.selectedUsers.splice(index, 1);
      } else {
        this.selectedUsers.push(user);
      }
    },

    isUserSelected(userID) {
      return this.selectedUsers.some(u => u.userID === userID);
    },

    async processNextSelectedUser(currentIndex = 0) {
      this._multiSelectIndex = currentIndex;

      if (this._multiSelectIndex >= this.selectedUsers.length) {
        // Todos os usuários foram processados
        this.loading = false;
        this.visible = false;
        this.selectedUsers = [];
        this.isMultiSelectActive = false;
        this._multiSelectQueue = [];
        this._multiSelectIndex = 0;
        this._currentContextUser = null;
        this._currentContextArgs = null;
        this.showMessage('Sucesso', 'Alocação dos plantonistas concluída.');
        return;
      }

      this.loading = true;
      const currentUser = this.selectedUsers[this._multiSelectIndex];


      this._currentContextUser = currentUser;
      this._currentContextArgs = { checkScaleDutyManualConflicts: true, checkScaleDutyJourneyConflicts: true, checkDutyConflicts: true, checkRuleViolations: true };


      const result = await this.addUserToScale(currentUser, this._currentContextArgs);

      if (result.success) {
        this.processNextSelectedUser(this._multiSelectIndex + 1);
      } else if (result.reason === 'confirm_needed') {
        // Se uma confirmação é necessária, exibe o popup
        this.loading = false;
        await this.showConfirmBox(result);
      } else {
        // Se falhou por outro motivo (bloqueio, erro interno), desativa o loading
        this.loading = false;
        this.showMessage('Erro', `Não foi possível adicionar ${currentUser.userName}: ${result.message || result.reason}`);
        // Continua para o próximo usuário, pulando o que falhou
        this.processNextSelectedUser(this._multiSelectIndex + 1);
      }
    },

    async confirmMultipleSelection() {
      if (this.selectedUsers.length === 0) {
        this.showMessage('Aviso', 'Nenhum usuário selecionado para adicionar à escala.');
        return;
      }

      this._multiSelectQueue = [...this.selectedUsers];
      this._multiSelectIndex = 0;

      await this.processNextSelectedUser(this._multiSelectIndex);
    },
  }
}
